const getDerivatives = ({top, left, bottom, right}) => {
  const dzdx = right - left;
  const dzdy = top - bottom;

  return {
    dzdx,
    dzdy,
  }
}

const getSlope = ({dzdx, dzdy}, z=.2) => Math.atan(z * Math.sqrt(dzdx ** 2 + dzdy ** 2));
const getAspect = ({dzdx, dzdy}) => {
  return Math.atan2(-dzdy, -dzdx);
};
const getReflectance = ({aspect, slope, sunAzimuth, sunElevation}) => {
  return Math.cos(Math.PI * .5 - aspect - sunAzimuth) * Math.sin(slope) * Math.sin(Math.PI * .5 - sunElevation) +
    Math.cos(slope) * Math.cos(Math.PI * .5 - sunElevation);
};

const brighten = n => n*.7 + .3;

const hillShader = ({x, y, width, height, raster, nodatavalue}) => {
  const sunAzimuth = 290;
  const sunElevation = 75;
  const minValue = -100

  let top,left,right,bottom;

  try {
     top = raster[Math.max(0,y-1)][x];
     left = raster[y][Math.max(0,x-1)];
     right = raster[y][Math.min(width-1,x+1)];
     bottom = raster[Math.min(height-1,y+1)][x];
  } catch (e) {
    return -1
  }



  if (top === nodatavalue || bottom === nodatavalue || right === nodatavalue || left === nodatavalue) {
    return -1
  }

  // a bit dirty, but the zoom function from cogeo "merges" nodata and the last known value. So we end up with some werid grey
  if (top < minValue || bottom < minValue || right < minValue || left < minValue) {
    return -1
  }

  const derivitives = getDerivatives({top, left, bottom, right});
  const slope = getSlope(derivitives, 0.2);
  const aspect = getAspect(derivitives);

  if (top === 0 && left === 0 && bottom === 0 && right === 0) {
    return -1;
  }

  let reflectance = getReflectance({aspect, slope, sunAzimuth, sunElevation});
  if (reflectance < 0) {
    reflectance = 0;
  }
  return brighten(reflectance);

};

export default hillShader;